import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Nav from './Nav';

function NotFound() {
  return (
    <Container className="py-5">
      <Nav />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        padding: '2rem',
      }}>
        <h1 style={{
          fontSize: '6rem',
          fontWeight: 'bold',
          color: '#1a1a1a',
          marginBottom: '0.5rem',
        }}>
          404
        </h1>
        <h2 style={{
          fontSize: '1.5rem',
          color: '#666',
          marginBottom: '1rem',
        }}>
          Page Not Found
        </h2>
        <p style={{
          fontSize: '1rem',
          color: '#888',
          maxWidth: '400px',
          marginBottom: '2rem',
        }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link
            to="/"
            style={{
              padding: '12px 24px',
              backgroundColor: '#1a1a1a',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '50px',
              fontSize: '1rem',
              fontWeight: '500',
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}
          >
            Back to Home
          </Link>
          <Link
            to="/brands"
            style={{
              padding: '12px 24px',
              backgroundColor: 'transparent',
              color: '#1a1a1a',
              textDecoration: 'none',
              borderRadius: '50px',
              fontSize: '1rem',
              fontWeight: '500',
              border: '1px solid #1a1a1a',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#1a1a1a';
            }}
          >
            Explore Brands
          </Link>
        </div>
      </div>
    </Container>
  );
}

export default NotFound;
